module.exports = __webpack_public_path__ + "static/media/cq_elenco.033071b4.svg";